import * as types from './constants';

// Get Group Users
export const getGroupUsersRequest = data => (
  { type: types.GET_GROUP_USERS_REQUEST, payload: data }
);

export const getGroupUsersDone = data => (
  { type: types.GET_GROUP_USERS_DONE, payload: data }
);

export const getGroupUsersFailed = errors => (
  { type: types.GET_GROUP_USERS_FAILED, payload: errors }
);

// Operations
export const groupUsersSetPage = data => (
  { type: types.GROUP_USERS_SET_PAGE, payload: data }
);